import { isPastDueDate } from '../../../shared/utils/overdue';

export const DOCUMENT_OVERVIEW_LABELS = {
  thisWeek: 'Questa settimana',
  totalDocuments: 'Totale Documenti',
  toComplete: 'Da completare',
  overdue: 'Scaduti',
};

export function getDocumentDueDate(document = {}) {
  if (Object.prototype.hasOwnProperty.call(document, 'dueDate')) return document.dueDate || '';
  const formData = document.formData || {};
  if (Object.prototype.hasOwnProperty.call(formData, 'dueDate')) return formData.dueDate || '';
  return formData.dataScadenza || document.dataScadenza || '';
}

export function isDocumentToComplete(document) {
  return document.status !== 'completato';
}

export function isDocumentOverdue(document, now = new Date()) {
  return isDocumentToComplete(document) && isPastDueDate(getDocumentDueDate(document), now);
}

export function filterDocumentsByOverview(documents = [], overview, now = new Date()) {
  if (overview === 'toComplete') return documents.filter(isDocumentToComplete);
  if (overview === 'overdue') return documents.filter((document) => isDocumentOverdue(document, now));
  if (overview !== 'thisWeek') return documents;
  const start = new Date(now);
  start.setDate(start.getDate() - (start.getDay() || 7) + 1);
  start.setHours(0, 0, 0, 0);
  const end = new Date(start);
  end.setDate(end.getDate() + 7);
  return documents.filter((document) => {
    const date = new Date(document.uploadDate);
    return date >= start && date < end;
  });
}
